import React from 'react';
import moment from 'moment';
import { ListGroup, ListGroupItem, Row, Col } from 'react-bootstrap';

const ChangeReasonDetails = props => {
  const auditDetails = JSON.parse(props.auditDetails);

  return (
    <ListGroup>
      <ListGroupItem className="listGroupItem1">
        <Row>
          <Col xs={12} className="listGroupItemCol1">
            User Details: <span className="dealer-edit-audit-detail">{props.user} </span>
          </Col>
        </Row>
      </ListGroupItem>
      <ListGroupItem className="listGroupItem1">
        <Row>
          <Col xs={12} className="listGroupItemCol1">
            Date:{' '}
            <span className="dealer-edit-audit-detail"> {moment(props.date).format('LLL')}</span>
          </Col>
        </Row>
      </ListGroupItem>

      <ListGroupItem className="listGroupItem1">
        <Row>
          <Col xs={12} className="listGroupItemCol1">
            Reason for change:{' '}
            <span className="dealer-edit-audit-detail"> {auditDetails.reason}</span>
          </Col>
        </Row>
      </ListGroupItem>
      <ListGroupItem className="listGroupItem1">
        <Row className="dealer-edit-audit-container">
          <Col xs={12} className="listGroupItemCol1">
            Audit Details:{' '}
            {auditDetails.features.map(details => (
              <ListGroupItem className="dealer-edit-audit-container" key={details.featureName}>
                <Row className="listGroupItemCol1 hr-line">
                  <Col xs={12}>
                    Feature Name:{' '}
                    <span className="dealer-edit-audit-detail"> {details.featureName}</span>
                    <br />
                    Is Enabled:{' '}
                    <span className="dealer-edit-audit-detail"> {details.isEnabled}</span>
                  </Col>
                </Row>
              </ListGroupItem>
            ))}
          </Col>
        </Row>
      </ListGroupItem>
    </ListGroup>
  );
};

export default ChangeReasonDetails;



// WEBPACK FOOTER //
// ./src/components/Dealers/ChangeReason/ChangeReasonDetails.js